import React, { useEffect, useMemo, useState } from "react";
import LastActivity from "../../Last_Activity/LastActivity";
import { ANSWERS, RESPONSE_COLORS } from "../../../../helpers/constants";
import { getAnswerColor, getAnswerText } from "../../../../helpers/utils";

const AdminResponseContainer = ({
  questionId,
  categoryData,
  prevAnswer,
  ...rest
}) => {
  const [colorId, setColorId] = useState(0);
  const [lastupdated, setLastUpdated] = useState({});
  const [rateOfComplete, setRateOfComplete] = useState();

  const rateChart = () => {
    const ratings = [];
    for (let i = 1; i <= 5; i++) {
      ratings.push(
        <div
          key={i}
          className={
            rateOfComplete === i
              ? "selectedRating rate-number admin-rate"
              : "rate-number admin-rate"
          }
        >
          {i}
        </div>
      );
    }
    return ratings;
  };

  useEffect(() => {
    if (prevAnswer) {
      const relevantAnswer = categoryData?.category
        ? prevAnswer.find(
            (prev) => prev?.category === categoryData?.category_id
          )
        : prevAnswer;

      setColorId(parseInt(relevantAnswer?.answer, 10));
      setRateOfComplete(relevantAnswer?.rating);
      if (categoryData?.category)
        setLastUpdated({
          updatedAt: relevantAnswer?.updated_at,
          updatedBy: relevantAnswer?.updated_by,
        });
    }
  }, [prevAnswer]);

  return (
    <div
      className={
        categoryData && categoryData?.category
          ? "admin-category-response-wrapper"
          : "admin-response-wrapper"
      }
    >
      <div className="admin-response-header">
        <div className="admin-response-container">
          <div className="smiley-container">
            <div className="response-category-name">
              {categoryData && categoryData?.category}
            </div>
            <div style={{ display: "flex" }}>
              <div
                className="response-text"
                style={{ color: getAnswerColor(colorId) }}
              >
                {getAnswerText(colorId)}
              </div>
            </div>
          </div>
        </div>
        {Object.keys(lastupdated).length > 0 ? (
          <LastActivity
            updatedAt={lastupdated?.updatedAt}
            category={categoryData}
            qnId={questionId}
            {...rest}
          />
        ) : (
          ""
        )}
      </div>
      {colorId === ANSWERS.Incomplete && (
        <div className="rate">
          <span>
            Rate on a scale of 1 to 5, 1 being least complete and 5 being most
            complete.
          </span>
          <div className="ratingButtons">{rateChart()}</div>
        </div>
      )}
    </div>
  );
};

export default AdminResponseContainer;
